import { createSlice } from "@reduxjs/toolkit";

const filterOptionsSlice = createSlice({
    name: "filterData",
    initialState: {
        companyFilterOptions: [],
        sportFilterOptions: [],
        locationFilterOptions: [],
        receiverFilterOptions: [],
        playerOrTermNameOptions: [],
        marketTagOptions: [],
        eSportTitleOptions: [],
        tournmentLevelOptions: [],
        group: [],
        channel: [],
        sport: [],
        event: [],
        tournament: [],
        property: [],
        player: [],
        bet_type: [],
        alertsActiveIndex: null,
        sportActiveIndex: null,
        messageCount : 0
    },
    reducers: {
        storeFilterOptions(state, action) {
            const { key, options } = action.payload;
            state[key] = options;
        },
        clearFilterOptions(state, action) {
            state.companyFilterOptions = [];
            state.sportFilterOptions = [];
            state.locationFilterOptions = [];
            state.receiverFilterOptions = [];
            state.playerOrTermNameOptions = [];
            state.marketTagOptions = [];
            state.eSportTitleOptions = [];
            state.tournmentLevelOptions = [];
            state.alertsActiveIndex = null;
            state.sportActiveIndex = null;
            state.group = [];
            state.channel = [];
            state.sport = [];
            state.event =  [];
            state.tournament =  [];
            state.property =  [];
            state.player =  [];
            state.bet_type =  [];
            
        },
        setMessageCount(state, action) {
            state.messageCount = action.payload
        }
    },
});

export const filterOptionsActions = filterOptionsSlice.actions;
export default filterOptionsSlice.reducer;
